import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NotificationPopupComponent} from './notification-popup/notification-popup.component';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NotificationOpenServiceComponent} from './notification-open-service/notification-open-service.component';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {vssProviders} from '../../vss.providers';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import {PipeModule} from '../pipe/pipe.module';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    NotificationPopupComponent,
    NotificationOpenServiceComponent,
    ModalConfirmComponent
  ],
  exports: [
    NotificationPopupComponent,
    NotificationOpenServiceComponent,
    ModalConfirmComponent
  ],
    imports: [
        CommonModule,
        NzModalModule,
        NzButtonModule,
        NzIconModule,
        PipeModule,
        TranslateModule
    ],
  providers: [...vssProviders]
})
export class NotificationModule { }
